import styled from '@bd/bdui-styles/emotion';
import Carousel from './Carousel';

export default styled(Carousel)`
  .Carousel_imageEnlargeButton {
    display:none;
  }
  .Carousel_image {
    padding:0;
    height:calc(80vh - 60px);
    position: relative;
    @media (min-width: 768px) {
      padding:56% 0 0 0;
    }
    @media (min-width: 1199px) {
      padding:0;
      height:calc(100vh - 100px);
    }
  }
  .Carousel_imageButtonLeft, .Carousel_imageButtonRight {
    width:43px;
    height:77px;
    background-size:cover;
  }
  .Carousel_imageButtonLeft {
    background-image: url(/images/icon-arrow-left-blue.svg);
    left: 0;
  }

  .Carousel_imageButtonRight {
    background-image: url(/images/icon-arrow-right-blue.svg);
    right: 0;
  }
  .Carousel_imageEnlargeButton {
    display:none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/CarouselHome.js